import styled, { keyframes, css } from 'styled-components';



export const ANIMATION_DURATION_IN_MS = 1000;

const animation = /*#__PURE__*/keyframes(["to{opacity:0;transform:scale(2);}"]);






const animationRule = /*#__PURE__*/css(["animation:", " ", "ms;animation-iteration-count:1;"],
animation, ANIMATION_DURATION_IN_MS);



export const RippleSurface = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__RippleSurface", componentId: "sc-hpo33u-0" })(["overflow:hidden;position:relative;"]);




export const RippleEffect = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__RippleEffect", componentId: "sc-hpo33u-1" })(["position:absolute;top:", "px;left:", "px;width:", "px;height:", "px;border-radius:50%;opacity:1;transform:scale(0);background-color:", ";", ";"],

(props) => props.y,
(props) => props.x,
(props) => props.size,
(props) => props.size,





(props) => {var _props$color;return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : props.theme.colors['Level 2'];},

animationRule);